var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rose-chart"}},[_c('div',{staticClass:"rose-chart-title"},[_vm._v("商户门类销售占比")]),_c('dv-charts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }